import { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router";
import Icon from "../../components/Icon/Icon";
import CaretUp from "../../icons/caret-up.svg";
import styles from "./GoToTop.module.scss";

export const GoToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  const location = useLocation();
  useEffect(() => {
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  }, [location]);

  const handleScrollToTop = (e) => {
    e.stopPropagation();
    window.scroll({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const listener = (event) => {
      if (!isVisible && event?.path?.[1]?.scrollY > window.innerHeight / 2)
        setIsVisible(true);
      if (isVisible && event?.path?.[1]?.scrollY < window.innerHeight / 2)
        setIsVisible(false);
    };

    window.addEventListener("scroll", listener);

    return () => window.removeEventListener("scroll", listener);
  }, [isVisible]);

  return isVisible ? (
    <button onClick={handleScrollToTop} className={styles.toTopButton}>
      <Icon name={CaretUp} />
    </button>
  ) : null;
};
